import { Label } from '@mairistem/composants';
import type React from 'react';

interface SquareTagProps {
  /** Texte affiché dans le tag */
  text: string;
  /** Couleur du tag (couleurs Semantic UI) */
  color?:
    | 'red'
    | 'yellow'
    | 'green'
    | 'blue'
    | 'orange'
    | 'teal'
    | 'purple'
    | 'pink'
    | 'brown'
    | 'grey';
  /** Si true, affiche une ligne barrée sur le tag */
  strikethrough?: boolean;
  /** Texte d'infobulle au survol */
  title?: string;
}

const SquareTag: React.FC<SquareTagProps> = ({ text, color, strikethrough = false, title }) => (
  <Label size="small" basic color={color} title={title} className="square-tag">
    {text}
    {strikethrough && <div className="square-tag-strikethrough" />}
  </Label>
);

export default SquareTag;
